import { LinearProgress, OutlinedInput } from '@mui/material'
import Checkbox from '@mui/material/Checkbox'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import ListItemText from '@mui/material/ListItemText'
import MenuItem from '@mui/material/MenuItem'
import Select, { SelectChangeEvent } from '@mui/material/Select'
import React from 'react'

interface MultiSelectDropdownProps {
  label: string
  options: string[]
  defaultValue?: string[] // Array for multiple values
  disableOptions?: string[]
  styles?: any
  onChange: (value: string[]) => void // Array for multiple values
  fullWidth?: boolean
  loading?: boolean
}

const MultiSelectDropdown: React.FC<MultiSelectDropdownProps> = ({
  label,
  options,
  defaultValue = [], // Initialize defaultValue as an empty array
  disableOptions = [],
  styles = {},
  onChange,
  fullWidth,
  loading = false,
}) => {
  const handleChange = (event: SelectChangeEvent<string[]>) => {
    const value = event.target.value as string[]
    onChange(value)
  }

  return (
    <FormControl
      sx={{ minWidth: 180, ...styles }}
      size='small'
      fullWidth={fullWidth}
    >
      <InputLabel id={`${label}-label`}>
        {loading ? 'Loading...' : label}
      </InputLabel>
      <Select
        labelId={`${label}-label`}
        id={`${label}-select`}
        multiple // Enable multiple selection
        value={defaultValue}
        onChange={handleChange}
        disabled={loading}
        input={<OutlinedInput label={loading ? 'Loading...' : label} />}
        renderValue={(selected) => (selected as string[]).join(', ')} // Show selected values as a comma-separated string
      >
        {loading ? (
          <MenuItem value=''>
            <LinearProgress />
          </MenuItem>
        ) : (
          options.map((option, index) => (
            <MenuItem
              sx={{ padding: 0, paddingRight: 1 }}
              key={index + 1}
              value={option}
              disabled={disableOptions.includes(option)}
            >
              <Checkbox checked={(defaultValue as string[]).includes(option)} />
              <ListItemText primary={option} />
            </MenuItem>
          ))
        )}
      </Select>
    </FormControl>
  )
}

export default MultiSelectDropdown
